import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, {
  Fragment,
  Component,
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { InvestmentOther as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import { withHousehold } from 'Context/HouseholdContext';
import useAffordance from 'Hooks/useAffordance';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import ExtraordinaryWindfallsPicker
  from '../ResourceSections/ExtraordinaryWindfall/ExtraordinaryWindfallsPicker';
import ExtraordinaryLifeChangePicker
  from '../ResourceSections/ExtraordinaryLifeChange/ExtraordinaryLifeChangePicker';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import Section from '../Section';
import BoolInput from '../Fields/BoolInput';
import TextareaInput from '../Fields/TextareaInput';
import RadioInput from '../Fields/RadioInput';
import ExtraordinaryExpenseSectionPicker
  from '../ResourceSections/ExtraordinaryExpense/ExtraordinaryExpenseSectionPicker';

export const militaryBranchTypes = [
  {
    id: 'air force',
    text: 'Air Force',
  },
  {
    id: 'army',
    text: 'Army',
  },
  {
    id: 'coast guard',
    text: 'Coast Guard',
  },
  {
    id: 'marine corps',
    text: 'Marine Corps',
  },
  {
    id: 'navy',
    text: 'Navy',
  },
  {
    id: 'other',
    text: 'Other',
  },
];

class LocalTextArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.title,
    };

    this.inputDidChange = this.inputDidChange.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  inputDidChange(_, val) {
    const {
      props: { title },
    } = this;
    let firstLine = val.split('\n')[0];
    firstLine = firstLine.length < 55 ? firstLine : `${firstLine.substr(0, 55)}...`;

    this.setState({
      title: firstLine === '' ? title : firstLine,
    });
  }

  render() {
    const {
      state: { title },
      props: {
        answerKey,
        removeButton,
        // onChange,
        title: placeholder,
        expanded,
      },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={title}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextareaInput
          ref={this.input}
          name={answerKey}
          answerKey={answerKey}
          placeholder={placeholder}
          onChange={this.inputDidChange}
        />
      </LabeledVerticalExpander>
    );
  }
}

LocalTextArea.propTypes = {
  answerKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  removeButton: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

LocalTextArea.defaultProps = {
  expanded: false,
};

const Expenses = ({ children, expanded }) => (
  <LocalTextArea
    answerKey="expensesText"
    title="Expense"
    removeButton={children}
    expanded={expanded}
  />
);

Expenses.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

Expenses.defaultProps = {
  expanded: false,
};

const Windfalls = ({ children, expanded }) => (
  <LocalTextArea
    answerKey="windfallsText"
    title="Windfall"
    removeButton={children}
    expanded={expanded}
  />
);

Windfalls.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

Windfalls.defaultProps = {
  expanded: false,
};

const LifeChanges = ({ children, expanded }) => (
  <LocalTextArea
    answerKey="lifeChangesText"
    title="Change"
    removeButton={children}
    expanded={expanded}
  />
);

LifeChanges.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

LifeChanges.defaultProps = {
  expanded: false,
};

function InvestmentOther() {
  const { getQuestionnaireAnswer } = useSwaggerlessContext();
  const [militaryBranchType, setMilitaryBranchType] = useState(null);
  const [expensesCount, setExpensesCount] = React.useState(0);
  const [windfallCount, setWindfallCount] = React.useState(0);
  const [changesCount, setChangesCount] = React.useState(0);

  const { householdResource } = useSimpleHousehold();
  const {
    collection: clientCollection,
  } = useAffordance(householdResource?.relationship(fr.relationships.clients.name).link('related'), {
    onlyRunOnMount: true,
  });
  const primaryClientResource = clientCollection?.resources().list().find(c => c.attr('isPrimary') === 'true');

  useEffect(() => {
    getQuestionnaireAnswer(householdResource.id(), 'militaryBranchType')
      .then(res => setMilitaryBranchType(res.attributes.value));
  }, [householdResource]);

  if (militaryBranchType === null) {
    return null;
  }

  return (
    <Section
      transitionSpeed={0.25}
      title="Other"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<Box className="expander-header-multi-count expander-header-left"><Typography>Expenses</Typography><CircleWithCount count={expensesCount} className="expander-header-count" /><Typography>Windfalls</Typography><CircleWithCount count={windfallCount} className="expander-header-count" /><Typography>Changes</Typography><CircleWithCount count={changesCount} className="expander-header-count" /></Box>}
    >
      <ExtraordinaryExpenseSectionPicker
        clientResource={primaryClientResource}
        setExpensesCount={setExpensesCount}
        Expenses={Expenses}
      />
      <ExtraordinaryWindfallsPicker
        clientResource={primaryClientResource}
        setWindfallCount={setWindfallCount}
        Windfalls={Windfalls}
      />
      <ExtraordinaryLifeChangePicker
        clientResource={primaryClientResource}
        setChangesCount={setChangesCount}
        LifeChanges={LifeChanges}
      />
      <BoolInput
        label="Do you have military service?"
        name="hasMilitaryService"
        answerKey="hasMilitaryService"
        checkedChildren={
          <Fragment>
            <BoolInput
              label="Are you currently active duty?"
              name="militaryActiveDuty"
              answerKey="militaryActiveDuty"
            />
            <RadioInput
              className="military-branch-type"
              label="For which branch of the military?"
              name="militaryBranchType"
              answerKey="militaryBranchType"
              options={militaryBranchTypes}
              onChange={(n, v) => setMilitaryBranchType(v)}
            />
            {militaryBranchType === 'other' && (
              <div>
                <br />
                <TextareaInput
                  name="militaryServiceDescription"
                  answerKey="militaryServiceDescription"
                  placeholder="Military Service Description"
                />
              </div>
            )}
          </Fragment>
        }
      />
    </Section>
  );
}

InvestmentOther.propTypes = {
};

InvestmentOther.defaultProps = {};

export default withHousehold(InvestmentOther);
